var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 17,
    viewBox: "0 0 24 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_89_1933)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 6.21323H24V11.5803H0V6.21323Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0.84613H24V6.21322H0V0.84613ZM0 11.5803H24V16.9474H0V11.5803Z",
    fill: "#D80027"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_89_1933"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 16.1013,
    fill: "white",
    transform: "translate(0 0.84613)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAt);
export default __webpack_public_path__ + "static/media/AT.029070305952877af9cee8d56961732d.svg";
export { ForwardRef as ReactComponent };